<div class="container">

  <app-header-dialog [iconName]="'local_atm'">
    Voucher
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <div class='tab-content-id'>

      <span *ngIf='!isEdit'>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Usuário (4 letras iniciais)</mat-label>>
          <input matInput #pacienteEscolhido type="text" [matAutocomplete]="autoPaciente"
            [formControl]="searchMemberControl">
          <mat-autocomplete #autoPaciente="matAutocomplete" [displayWith]="displayMember.bind(this)">
            <mat-option *ngFor="let member of members" [value]="member">
              {{ member.name }}
              <span *ngIf="member.email"> | <small>{{ member.email }}</small></span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>

      <mat-form-field class="full-width" *ngIf='isEdit' appearance="outline">
        <mat-label>Usuário</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.member_name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.member_name.hasError('required')">
          O Usuário é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" *ngIf='isEdit' appearance="outline">
        <mat-label>Emai]l</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.member_email"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.member_email.hasError('required')">
          O Email é obrigatório
        </mat-error>
      </mat-form-field>


      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Produto</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.product_name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.product_name.hasError('required')">
          O Produto é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Patrocínio</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.sponsor_name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.sponsor_name.hasError('required')">
          O Patrocínio é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="width-200" appearance="outline">
        <mat-label>Código</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
          O Código é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="width-200" appearance="outline">
        <mat-label>Valor</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.discount"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.discount.hasError('required')">
          O Valor é obrigatório.
        </mat-error>
      </mat-form-field>

      <div style="display:flex; flex-direction: row; justify-content: space-between;">
        <div *ngIf='isEdit' style='width: 200px; border-bottom: solid 1px silver; margin: 10px 0 20px 0;'>
          Enviado em: {{ entityForm.controls.date_sent.value | date: 'dd/MM/yyyy' }}
        </div>

        <mat-checkbox *ngIf='isEdit' color='primary' [formControl]="entityForm.controls.used">
          Usado
        </mat-checkbox>

      </div>

    </div>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf='!isEdit'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>